module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"gl-events-calendar\">\n	<div class=\"header\">\n		<div class=\"table w100\">\n			<div>\n				<div class=\"buttons\">\n					<button on-click=\"onPrevClick\"><i class=\"icon-16 icon-arrow-left\"></i></button>\n					<button on-click=\"onNextClick\"><i class=\"icon-16 icon-arrow-right\"></i></button>\n				</div>\n\n				")
    ;  if (widget.showDateSelector) { 
    ; __append("\n				<div>\n					<input type=\"text\" name=\"goToDate\" placeholder=\"Перейти на дату\">\n				</div>\n				")
    ;  } 
    ; __append("\n\n				<div class=\"month-name\"><span name=\"month-name\"></span></div>\n			</div>\n		</div>\n	</div>\n\n	<div class=\"cells\" name=\"cells\">\n		<table class=\"w100\">\n			<thead>\n			<tr>\n				<td>")
    ; __append(escapeFn( widget.localization.Monday ))
    ; __append("</td>\n				<td>")
    ; __append(escapeFn( widget.localization.Tuesday ))
    ; __append("</td>\n				<td>")
    ; __append(escapeFn( widget.localization.Wednesday ))
    ; __append("</td>\n				<td>")
    ; __append(escapeFn( widget.localization.Thursday ))
    ; __append("</td>\n				<td>")
    ; __append(escapeFn( widget.localization.Friday ))
    ; __append("</td>\n				<td>")
    ; __append(escapeFn( widget.localization.Saturday ))
    ; __append("</td>\n				<td>")
    ; __append(escapeFn( widget.localization.Sunday ))
    ; __append("</td>\n			</tr>\n			</thead>\n\n			<tbody>\n			")
    ;  for (var i = 0; i < 6; i++) { 
    ; __append("\n			<tr>\n				")
    ;  for (var j = 0; j < 7; j++) { 
    ; __append("\n					<td data-index=\"")
    ; __append(escapeFn( i + '-' + j ))
    ; __append("\"></td>\n				")
    ;  } 
    ; __append("\n			</tr>\n			")
    ;  } 
    ; __append("\n			</tbody>\n		</table>\n	</div>\n</div>\n\n")
  }
  return __output.join("");

}